import { render } from "./HsCodeManage.vue?vue&type=template&id=406ea4a0&scoped=true"
import script from "./HsCodeManage.vue?vue&type=script&lang=js"
export * from "./HsCodeManage.vue?vue&type=script&lang=js"

import "./HsCodeManage.vue?vue&type=style&index=0&id=406ea4a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406ea4a0"]])

export default __exports__